import { Duration } from 'luxon/src/duration';
import React, { FC } from 'react';

interface TimerItemProps {
  readonly value: number;
}

const TimerItem: FC<TimerItemProps> = ({ value }) => {
  const formattedValue = value.toString().length >= 2 ? value : `0${value}`;

  return <>{formattedValue}</>;
};

export interface RoundTimerProps {
  readonly duration: Duration;
}

export const RoundTimer: FC<RoundTimerProps> = ({ duration }) => (
  <div>
    <TimerItem value={duration.hours} />:
    <TimerItem value={duration.minutes} />:
    <TimerItem value={duration.seconds} />
  </div>
);
